import { render, staticRenderFns } from "./Intention.vue?vue&type=template&id=38bff3b9&scoped=true&"
import script from "./Intention.vue?vue&type=script&lang=js&"
export * from "./Intention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bff3b9",
  null
  
)

export default component.exports